import axios from "axios";

export default {
  name: "closingUM",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getListClosingUM(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "um_close",
          params: { tlc: auth.username },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // getBuktiPS(store, { auth, id }) {
    //   return new Promise((resolve, reject) => {
    //     axios({
    //       method: "get",
    //       url:
    //         process.env.VUE_APP_SERVICEURL + "payment_schedule/bukti_transfer",
    //       params: {
    //         id_payment_schedule: id,
    //       },
    //       auth: {
    //         username: auth.username,
    //         password: auth.password,
    //       },
    //       headers: {
    //         "X-API-KEY": auth.apikey,
    //       },
    //     })
    //       .then((response) => {
    //         resolve(response);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
    postClosingUM(store, { auth, data }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "um_close/close_um",
          data: data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data, status }) => {
            console.log(status);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
